import { Link } from '@rumblefish/ui/src/components/Rumblefish23Theme';
import parse from 'html-react-parser';
import React from 'react';

import { mobileServicesData } from './MobileServices.data';
import {
  StyledFrame,
  StyledImage,
  StyledStack,
  StyledButton,
  StyledSection,
  StyledHeadline,
  StyledInfoTitle,
  StyledInfoSection,
  StyledInfoWrapper,
  StyledButtonWrapper,
  StyledHeadlineWrapper,
  StyledInfoDescription,
  StyledColumnInfoWrapper,
  StyledSingleInfoWrapper,
  StyledHeadlineDescription,
} from './styles';
import { StaticImageData } from 'next/image';

export const MobileServices = (): React.ReactElement => {
  return (
    <StyledSection width="normal">
      <StyledStack>
        <StyledFrame>
          <StyledHeadlineWrapper>
            <StyledHeadline variant="display_sm">
              {mobileServicesData.mainText}
            </StyledHeadline>
            <StyledHeadlineDescription variant="strong_400">
              {mobileServicesData.description}
            </StyledHeadlineDescription>

            <StyledButtonWrapper>
              <Link to="/contact">
                <StyledButton>Let's get in touch!</StyledButton>
              </Link>
            </StyledButtonWrapper>
          </StyledHeadlineWrapper>

          {mobileServicesData.services.map((service, indexSingleInfo) => {
            const reverse = !!(indexSingleInfo % 2);
            const isLastService =
              mobileServicesData.services.length - 1 === indexSingleInfo;

            return (
              <StyledInfoSection
                reverse={reverse}
                bottomMargin={!isLastService}
                key={indexSingleInfo}>
                <StyledColumnInfoWrapper>
                  <StyledSingleInfoWrapper reverse={reverse}>
                    <StyledInfoTitle variant="strong_500">
                      {service.title}
                    </StyledInfoTitle>

                    <StyledInfoDescription variant="regular_400">
                      {parse(service.description || '')}
                    </StyledInfoDescription>
                  </StyledSingleInfoWrapper>
                </StyledColumnInfoWrapper>
                <StyledInfoWrapper>
                  <StyledImage
                    reverse={reverse}
                    src={(service.src as unknown as StaticImageData)?.src || ''}
                    alt={service.imageAlt || ''}
                  />
                </StyledInfoWrapper>
              </StyledInfoSection>
            );
          })}

          <StyledButtonWrapper sx={{ alignItems: 'center' }}>
            <Link to="/contact">
              <StyledButton typographyVariant="strong_500">
                Let's get in touch!
              </StyledButton>
            </Link>
          </StyledButtonWrapper>
        </StyledFrame>
      </StyledStack>
    </StyledSection>
  );
};
